import React from "react";
import PageHeader from "../../components/PageHeader";
import CmsViewComponent from "../../components/CmsPages/CmsView";

class CmsView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="CMS Detail"
                            Breadcrumb={[
                                { name: "CMS", navigate: "/cms-pages" },
                                { name: "CMS Detail", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CmsViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CmsView;
